import { render } from "./SecondaryView.vue?vue&type=template&id=2801b0e2"
import script from "./SecondaryView.vue?vue&type=script&lang=js"
export * from "./SecondaryView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__